<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
const { setOrganizationStructuredData } = useSEO()

// Set global organization-level structured data
onMounted(() => {
  try {
    setOrganizationStructuredData()
  } catch (error) {
    console.error('[App] Failed to set organization structured data:', error)
  }
})
</script>

<style>
</style>
